export var shadowColors = {text:'#005965'};